import { Attribute } from "../../types/prodcatBaseTypes";
import { getAttributeValues } from "../product/getAttributeValues";

export function getFabricRollLength(
  attributes: Attribute[],
): number | undefined {
  return (
    // @ts-ignore
    parseInt(getAttributeValues("fabricrolllength", attributes || [])[0]) ||
    undefined
  );
}
